//import { localStorage } from '@entrata/utils'
export default () => {
  var privacyServices = [];
  var PrivacyKeys = [];
  const  privacySetting = {
			'is_eu':false,
			'banner_description':'We use cookies and services to understand how you use our site and to improve your browsing experience. By clicking \'I Accept All Cookies\', closing the bar, or continuing to browse, you agree to the storing of cookies on your device. Your cookie settings can be changed at any time by clicking \'Cookie Preferences\' in the footer of this site. To find out more, please view our <a href=\'\' class=\'pc-link\' target=\'_blank\' rel=\'noopener\'>Privacy Policy<\/a>',
			'popup_description':'We use various cookies and services to improve the browsing experience on our website. Select the categories below to learn more about their purpose and choose which items you want to allow. You may change your preferences at any time. You can learn more about our Privacy Policy <a href=\'\' class=\'pc-link\' target=\'_blank\' rel=\'noopener\'>here<\/a>',
			'is_user_defined':false,
			'cookie_name':'PRIVACY_SETTINGS_V1',
			'layout':'accordion',
			'groups':{
						'1':
						{
							'group_id':'1',
							'group_name':'Essential',
							'group_description':'These cookies and services help make our platforms work by enabling basic functions, such as page navigation and controlled access to secure parts of our platforms. Without these cookies, our platforms cannot function properly and securely. For example, cookies help us verify your account and device, and determine when you\u2019re logged in, so that we can make it easier for you to access our platforms and provide the appropriate experiences and features. We also use cookies to help prevent fraudulent use of login credentials. These cookies cannot be turned off because they are essential for our platforms to work.',
							'is_editable':false,
							'is_selected_default':false,
							'group_items':{
											'63':{
													'group_item_id':'63',
													'token':'rp_at',
													'group_item_name':'rp_at',
													'item_description':'used to store JWT Token, so the user\'s session is not get affected',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'64':{
													'group_item_id':'64',
													'token':'rp_us',
													'group_item_name':'rp_us',
													'item_description':'Used to store selected property and lease id after Login with multiple property\/ units scenario or from Change Unit section',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'67':{
													'group_item_id':'67',
													'token':'path',
													'group_item_name':'path',
													'item_description':'Used to idenify when user is redirected from responsive to RP4.0',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'69':{
													'group_item_id':'69',
													'token':'isConfirmMicroDeposit',
													'group_item_name':'isConfirmMicroDeposit',
													'item_description':'Used in Plaid workflow, to identify that the current flow is MicroDeposit and used to pass to the customer_plaid_items\/save API as a payload',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'70':{
													'group_item_id':'70',
													'token':'isRelinkAccount',
													'group_item_name':'isRelinkAccount',
													'item_description':'Used in Plaid workflow, to identify that the current flow is Relink Account flow and used to pass the key is_relink_account to the customer_plaid_items\/save API as a payload',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'71':{
													'group_item_id':'71',
													'token':'paymentAccountId',
													'group_item_name':'paymentAccountId',
													'item_description':'Used in Plaid workflow, to store  the payment_account_id and passed to the customer_plaid_items\/save API as a payload',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'72':{
													'group_item_id':'72',
													'token':'login_from_entrata',
													'group_item_name':'login_from_entrata',
													'item_description':'To identify Impersonated user and track login activity',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'73':{
													'group_item_id':'73',
													'token':'rp_cluster',
													'group_item_name':'rp_cluster',
													'item_description':'Used to identify release track (rapid or standard) of the client and prepare API URL accordingly',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'74':{
													'group_item_id':'74',
													'token':'rp_client_id',
													'group_item_name':'rp_client_id',
													'item_description':'Used for storing client id, needed for user confirmation flow',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'75':{
													'group_item_id':'75',
													'token':'rp_sso_token',
													'group_item_name':'rp_sso_token',
													'item_description':'Used to get and store SSO token for contact confirmation from URL, needed for user confirmation flow',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'81':{
													'group_item_id':'81',
													'token':'isPlaidLinkRefresh',
													'group_item_name':'isPlaidLinkRefresh',
													'item_description':'Used after Plaid flow success',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'83':{
													'group_item_id':'83',
													'token':'previousLocation',
													'group_item_name':'previousLocation',
													'item_description':'Used to manage location history in Amenity Payments',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'84':{
													'group_item_id':'84',
													'token':'paymentAmount',
													'group_item_name':'paymentAmount',
													'item_description':'Used to store payment amount entered or which came from previous page',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'85':{
													'group_item_id':'85',
													'token':'linkTokenExpiry',
													'group_item_name':'linkTokenExpiry',
													'item_description':'Used this key to store expiration details of the link token received from linkToken API',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'86':{
													'group_item_id':'86',
													'token':'newLinkToken',
													'group_item_name':'newLinkToken',
													'item_description':'Used to store new link token which we get once previous one expires',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'87':{
													'group_item_id':'87',
													'token':'formFields',
													'group_item_name':'formFields',
													'item_description':'Used to store all details entered by user, because once Plaid success we refresh the data should not get lost so we need to store and prepropulate the user entered data.',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'88':{
													'group_item_id':'88',
													'token':'paymentType',
													'group_item_name':'paymentType',
													'item_description':'Used to store selected payment type after Plaid re-initialization',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'89':{
													'group_item_id':'89',
													'token':'nonce',
													'group_item_name':'nonce',
													'item_description':'Used for store arbitrary number that we get from getPlaidInactiveAccounts and based on that we allow redirection',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'90':{
													'group_item_id':'90',
													'token':'autoPaymentType',
													'group_item_name':'autoPaymentType',
													'item_description':'Used to store auto payment type selected by used so that it won\'t be lost after Plaid re-initialization',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'95':{
													'group_item_id':'95',
													'token':'force_logout',
													'group_item_name':'force_logout',
													'item_description':'If no lease is found from getProductionPermissions API, then force user to logout',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												},
											'96':{
													'group_item_id':'96',
													'token':'rp_sd',
													'group_item_name':'rp_sd',
													'item_description':'Used to store all the resident, property, lease, unit, user_token and timezone related data',
													'is_editable':false,
													'is_default_state':false,
													'is_details_editable':false
												}
										}
						},
						'2':
						{
							'group_id':'2',
							'group_name':'Performance & Functionality',
							'group_description':'These cookies and services enhance the performance and functionality of this website. Without these cookies and services, certain functionality like maps or video may become unavailable.',
							'is_editable':true,
							'is_selected_default':false,
							'group_items':{
											'65':
												{
													'group_item_id':'65',
													'token':'language_updated_from_settings',
													'group_item_name':'language_updated_from_settings',
													'item_description':'This is used in language settings, to identify if the language is updated from setting',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'66':{
													'group_item_id':'66',
													'token':'checklistVideoPauseTime',
													'group_item_name':'checklistVideoPauseTime',
													'item_description':'This is used for Watch video checklist Items, to store the time when user paused it',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'68':{
													'group_item_id':'68',
													'token':'newPymentMethodAdded',
													'group_item_name':'newPymentMethodAdded',
													'item_description':'This is boolean value, it is used when, select any payment method or add new and then readjust the amount entered, the selected payment method shows as selected but it is not actually and at the bottom it shows as \'Required field\'',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'76':{
													'group_item_id':'76',
													'token':'background_url',
													'group_item_name':'background_url',
													'item_description':'Used to set the branding',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'77':{
													'group_item_id':'77',
													'token':'primary',
													'group_item_name':'primary',
													'item_description':'Used for branding color',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'78':{
													'group_item_id':'78',
													'token':'secondary',
													'group_item_name':'secondary',
													'item_description':'Used for branding color',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'79':{
													'group_item_id':'79',
													'token':'beforeLoginUrl',
													'group_item_name':'beforeLoginUrl',
													'item_description':'\'This is used for redirecting user to specific URL after login, used in custom documents (i.e. survey forms)\r\nIf this is set then user will be redirected to that particular survey\/form\'',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'80':{
													'group_item_id':'80',
													'token':'locale_update_cancelled',
													'group_item_name':'locale_update_cancelled',
													'item_description':'\'This is set when after login user sees a pop up for language change and the user cancels it\'',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												},
											'82':{
													'group_item_id':'82',
													'token':'login_tracked',
													'group_item_name':'login_tracked',
													'item_description':'\'-\'',
													'is_editable':true,
													'is_default_state':true,
													'is_details_editable':false
												}
										}
						}
					},
				'is_snippet':false
		}
  var defaultPrivacySetting	=	JSON.stringify(( window.rpSettings.privacyItems ) ? window.rpSettings.privacyItems : privacySetting)										
  var privacyItems =  JSON.parse(defaultPrivacySetting);
  const syncPrivacyItems = () => {
    // get privacy items from rpSettings
   
    //let PrivacyKeys = [];
       if (typeof privacyItems !== 'object') return; 
     // converting object to Array
     Object.keys(privacyItems).map((key) => ( privacyServices[key] = privacyItems[key] ) )

     // storing cookies and keys In PrivacyKeys
    // storing cookies and keys In PrivacyKeys
	Object.keys(privacyServices['groups']).map((key) => { 
        let Items = privacyServices['groups'][key].group_items;
        Object.keys(Items).map((group_key) => (
			PrivacyKeys[Items[group_key]['group_item_name']] = Items[group_key]))
      })
	  window.privacy_items = PrivacyKeys;
       
  }

  const isServiceEnabled = (value) => {
    return ( window.privacy_items && window.privacy_items[value]) ? true : false; 
  }

  return {
    syncPrivacyItems: syncPrivacyItems,
    isServiceEnabled: isServiceEnabled,
  }
  
  }


